import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/homebrew/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "js/bootstrap.js",
    "revision": "3ae5cb7b92474238c9cd6c9667771e8f"
  },
  {
    "url": "js/main.js",
    "revision": "9f6e65617cb7b7a67185b05427d97feb"
  },
  {
    "url": "js/app.min.js",
    "revision": "4f196ef1365d6ef38d2c681480ce618d"
  },
  {
    "url": "js/extensions.min.js",
    "revision": "65998885ad5af2f6a14315f3cd9e4d4c"
  },
  {
    "url": "js/orgchart.min.js",
    "revision": "619d8c4dab47b81868916df31f55478b"
  },
  {
    "url": "js/stencils.min.js",
    "revision": "5e2f2f82277b2cfc4c20b65da19bd1ca"
  },
  {
    "url": "js/shapes-14-6-5.min.js",
    "revision": "04c8d9b709f15514592b337ad33aad74"
  },
  {
    "url": "js/math-print.js",
    "revision": "cf64f6a493a8cb5079f2b70813e478d7"
  },
  {
    "url": "index.html",
    "revision": "9de11c65ec13b24c73ace7042bc529cc"
  },
  {
    "url": "open.html",
    "revision": "d71816b3b00e769fc6019fcdd6921662"
  },
  {
    "url": "shortcuts.svg",
    "revision": "2381dd779ce6cfee954042a7f784c7e6"
  },
  {
    "url": "styles/fonts/ArchitectsDaughter-Regular.ttf",
    "revision": "31c2153c0530e32553b31a49b3d70736"
  },
  {
    "url": "styles/grapheditor.css",
    "revision": "23cbac10c03279392888893b3f694007"
  },
  {
    "url": "styles/high-contrast.css",
    "revision": "4ecc9f6d08787a9e2d29dacf7aadd1ca"
  },
  {
    "url": "js/dropbox/Dropbox-sdk.min.js",
    "revision": "4b9842892aa37b156db0a8364b7a83b0"
  },
  {
    "url": "js/onedrive/OneDrive.js",
    "revision": "505e8280346666f7ee801bc59521fa67"
  },
  {
    "url": "connect/new_common/cac.js",
    "revision": "740dce44cf53499f476ee8edc37d09a0"
  },
  {
    "url": "connect/gdrive_common/gac.js",
    "revision": "3bb38a5d9186a896ed04808e921ef888"
  },
  {
    "url": "connect/onedrive_common/ac.js",
    "revision": "5fb6ff1a73f54a9086b7a7e1f613b8ed"
  },
  {
    "url": "math/es5/startup.js",
    "revision": "dc7130cdc866593293dbb5dde11ceb40"
  },
  {
    "url": "math/es5/core.js",
    "revision": "f71bc0bfb7d2ac8261747f97a5d47dd4"
  },
  {
    "url": "math/es5/ui/safe.js",
    "revision": "8c1fcfee7c879588ad409edcdd9cce53"
  },
  {
    "url": "math/es5/output/svg.js",
    "revision": "4f55967d16197ebb01b86356d8ab179a"
  },
  {
    "url": "math/es5/input/tex.js",
    "revision": "5c4f470da2ccb1acf85041fcecd6fff6"
  },
  {
    "url": "math/es5/input/asciimath.js",
    "revision": "c2d4076dd8e26d509bfe3a378e71cfa7"
  },
  {
    "url": "math/es5/output/svg/fonts/tex.js",
    "revision": "6eab785a3788ea805bd2b552d1f0aab8"
  },
  {
    "url": "resources/dia.txt",
    "revision": "66fe818e43b096f060797233ac192e69"
  },
  {
    "url": "resources/dia_da.txt",
    "revision": "2a4b2ad28cadf4590d62d490f88016eb"
  },
  {
    "url": "resources/dia_de.txt",
    "revision": "1388b25f6ecde6e330bf323017062c70"
  },
  {
    "url": "resources/dia_es.txt",
    "revision": "68daba33593d4fb5a1004ab3b6ac984d"
  },
  {
    "url": "resources/dia_fr.txt",
    "revision": "8641024bf63230b2786879723aaf0f0a"
  },
  {
    "url": "resources/dia_id.txt",
    "revision": "d571f949ace55bb011ab43c91f833b8e"
  },
  {
    "url": "resources/dia_it.txt",
    "revision": "7ff410073cee5c90d87df5dd7afd9a52"
  },
  {
    "url": "resources/dia_ja.txt",
    "revision": "6d704659a921836bac933bbc8e2cf935"
  },
  {
    "url": "resources/dia_ko.txt",
    "revision": "96c2009c94ce23da09702e42de356231"
  },
  {
    "url": "resources/dia_nl.txt",
    "revision": "cc83861bad1c0ee6407033e11dcf2a6e"
  },
  {
    "url": "resources/dia_pl.txt",
    "revision": "4576ed4793b8b1b6cea9e42e43563ff8"
  },
  {
    "url": "resources/dia_pt.txt",
    "revision": "4edd5e515438c38e3f1dc740a9004fd1"
  },
  {
    "url": "resources/dia_ru.txt",
    "revision": "40a32183dfcd22b3f1cbef39010193a4"
  },
  {
    "url": "resources/dia_vi.txt",
    "revision": "847c74fd08d2a5a5a0432a6a82ed2660"
  },
  {
    "url": "resources/dia_zh.txt",
    "revision": "e1b3588ff3149ec2123d1dd5c1f2e77a"
  },
  {
    "url": "favicon.ico",
    "revision": "b2bf17349e4b50ce4ba311f079f8bf7d"
  },
  {
    "url": "images/manifest.json",
    "revision": "421b4fae5b46499348d194e1f93558c3"
  },
  {
    "url": "images/logo.png",
    "revision": "e4e0d092abdb1e668b5ec41a7fe0713c"
  },
  {
    "url": "images/drawlogo.svg",
    "revision": "4bf4d14ebcf072d8bd4c5a1c89e88fc6"
  },
  {
    "url": "images/logo-flat-small.png",
    "revision": "4b178e59ff499d6dd1894fc498b59877"
  },
  {
    "url": "images/apple-touch-icon.png",
    "revision": "732c29e21332a926318a7005d21ec450"
  },
  {
    "url": "images/icon-192-maskable.png",
    "revision": "47e006d0ce4a35eb5beaa97f0c2bfed0"
  },
  {
    "url": "images/icon-192.png",
    "revision": "d022403d52435d76afec82c4e24a17ef"
  },
  {
    "url": "images/icon-512-maskable.png",
    "revision": "cf152feeb01fb21f3148a71a3540266e"
  },
  {
    "url": "images/icon-512.png",
    "revision": "a3a0df7e7a385244b74073f81ecc45de"
  },
  {
    "url": "images/delete.png",
    "revision": "5f2350f2fd20f1a229637aed32ed8f29"
  },
  {
    "url": "images/droptarget.png",
    "revision": "bbf7f563fb6784de1ce96f329519b043"
  },
  {
    "url": "images/logo-flat.png",
    "revision": "038070ab43aee6e54a791211859fc67b"
  },
  {
    "url": "images/google-drive-logo.svg",
    "revision": "5d9f2f5bbc7dcc252730a0072bb23059"
  },
  {
    "url": "images/onedrive-logo.svg",
    "revision": "3645b344ec0634c1290dd58d7dc87b97"
  },
  {
    "url": "images/dropbox-logo.svg",
    "revision": "e6be408c77cf9c82d41ac64fa854280a"
  },
  {
    "url": "images/github-logo.svg",
    "revision": "a1a999b69a275eac0cb918360ac05ae1"
  },
  {
    "url": "images/gitlab-logo.svg",
    "revision": "0faea8c818899e58533e153c44b10517"
  },
  {
    "url": "images/trello-logo.svg",
    "revision": "006fd0d7d70d7e95dc691674cb12e044"
  },
  {
    "url": "images/osa_drive-harddisk.png",
    "revision": "b954e1ae772087c5b4c6ae797e1f9649"
  },
  {
    "url": "images/osa_database.png",
    "revision": "c350d9d9b95f37b6cfe798b40ede5fb0"
  },
  {
    "url": "images/google-drive-logo-white.svg",
    "revision": "f329d8b1be7778515a85b93fc35d9f26"
  },
  {
    "url": "images/dropbox-logo-white.svg",
    "revision": "4ea8299ac3bc31a16f199ee3aec223bf"
  },
  {
    "url": "images/onedrive-logo-white.svg",
    "revision": "b3602fa0fc947009cff3f33a581cff4d"
  },
  {
    "url": "images/github-logo-white.svg",
    "revision": "537b1127b3ca0f95b45782d1304fb77a"
  },
  {
    "url": "images/gitlab-logo-white.svg",
    "revision": "5fede9ac2f394c716b8c23e3fddc3910"
  },
  {
    "url": "images/trello-logo-white-orange.svg",
    "revision": "e2a0a52ba3766682f138138d10a75eb5"
  },
  {
    "url": "images/spin.gif",
    "revision": "487cbb40b9ced439aa1ad914e816d773"
  },
  {
    "url": "images/aui-wait.gif",
    "revision": "5a474bcbd8d2f2826f03d10ea44bf60e"
  },
  {
    "url": "mxgraph/css/common.css",
    "revision": "81d1704d5ab9207e2e5c7fc84379dc1a"
  }
], {
  "ignoreURLParametersMatching": [/.*/]
});








